export function getCurrencySymbolCrypto(currencyCode) {
  switch (currencyCode) {
    case "BTC":
      return "COINBASE:BTCUSD";
    case "USDT":
      return "COINBASE:USDTUSD";
    case "ETH":
      return "COINBASE:ETHUSD";
    case "USDC":
      return "COINBASE:USDTUSDC";
      case "XRP":
      return "COINBASE:XRPUSD";
    default:
      return "COINBASE:USDTUSD";
  }
}
